<template>
  <div class="library__card card" @click.stop="activateModal" v-if="featured">
    <div class="card__logo-container">
      <div class="card__logo-wrapper">
        <img class="card__logo" :src="decode(vendor.logoURL)" v-if="vendor.logoURL">
        <span class="fa fa-adjust card__placeholder" aria-hidden="true" v-else></span>
      </div>
    </div>
    <div class="card__title">{{ vendor.name }}</div>
    <div class="card__description">{{ description }}</div>
    <div class="card__view-btn">Request</div>
  </div>
  <a class="library__card card" :href="decode(vendor.overviewURL)" v-else-if="vendor.overviewURL">
    <div class="card__logo-container">
      <div class="card__logo-wrapper">
        <img class="card__logo" :src="decode(vendor.logoURL)" v-if="vendor.logoURL">
        <span class="fa fa-adjust card__placeholder" aria-hidden="true" v-else></span>
      </div>
    </div>
    <div class="card__title">{{ vendor.name }}</div>
    <div class="card__description">{{ description }}</div>
    <div class="card__view-btn">Download  <span class="glyphicon glyphicon-download" aria-hidden="true"></span></div>
  </a>
  <div class="library__card card" @click.stop="activateModal" v-else>
    <div class="card__logo-container">
      <div class="card__logo-wrapper">
        <img class="card__logo" :src="decode(vendor.logoURL)" v-if="vendor.logoURL">
        <span class="fa fa-adjust card__placeholder" aria-hidden="true" v-else></span>
      </div>
    </div>
    <div class="card__title">{{ vendor.name }}</div>
    <div class="card__description">{{ description }}</div>
    <div class="card__view-btn">Request</div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FuelUtilities from "../../utils/FuelUtilities";

  export default {
    name: 'VendorCard',
    mixins: [FuelUtilities],
    props: {
      vendor: Object,
    },
    computed: {
      description() {
        return this.truncateDescription(this.decode(this.vendor.desc), 65);
      },
      modalData() {
        return { ...this.vendor };
      },
      featured() {
        return (this.vendor.featured === 1 || this.vendor.featured === '1');
      },
      modalKey() {
        return this.featured ? 'featuredVendorModal' : 'vendorModal';
      },
    },
    methods: {
      downloadOverview() {
        if (this.vendor.overviewURL != "") {
          window.location = this.decode(this.vendor.overviewURL);
        }
      },
      truncateDescription(description, length) {
        return description.length > length
          ? this.truncateString(description, length)
          : description;
      },
      truncateString(str, length) {
        return str.substring(0, length - 3) + "...";
      },
      activateModal() {
        this.$store.dispatch('main/showModal', this.modalKey);
        this.$store.dispatch('main/setProperty', { key: 'modalData', value: this.modalData });
      },
    },
  };
</script>
